<template>
    <div class="proforma-invoices-listings">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Sales</p>
                    <h2 class="listing-title d-inline-block mb-0">Invoices</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="$refs.drawer_invoice_form.show()">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <InvoicesTable/>
            <DrawerInvoiceForm ref="drawer_invoice_form"/>
        </b-container>
    </div>
</template>
<script>
import InvoicesTable from '@/views/Sales/Invoices/InvoicesTable'
import DrawerInvoiceForm from '@/views/Sales/Invoices/OffCanvasInvoices/InvoiceForm'

export default {
    components: {
        InvoicesTable,
        DrawerInvoiceForm,
    }
}
</script>